<template>
  <c-flex align="center" flex="1">
    <c-icon name="search" size="2.25rem" mr="md" color="brand.purple" />
    <c-box width="100%" max-width="24rem">
      <label class="sr-only" for="searchTerm">{{
        $t("productReturnV2.pastReturns.search.placeholder")
      }}</label>
      <c-input
        id="searchTerm"
        position="relative"
        px="0"
        mb="0.75rem"
        :is-full-width="true"
        background="transparent"
        border-radius="0"
        border-width="0"
        border-bottom-width="1px"
        border-color="transparent"
        border-bottom-color="brand.purple"
        focus-border-color="transparent"
        v-model.trim="searchTerm"
        autocomplete="off"
        :placeholder="$t('productReturnV2.pastReturns.search.placeholder')"
        @keyup="search(searchTerm)"
        @blur="search(searchTerm)"
        :_hover="{ borderBottomColor: 'brand.purple' }"
        :_focus="{ borderBottomColor: 'brand.purple' }"
        :_active="{ borderBottomColor: 'brand.purple' }"
      />
    </c-box>
  </c-flex>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { debounce } from "lodash";
import { CInput, CFlex, CBox, CIcon } from "@chakra-ui/vue";

export default defineComponent({
  components: {
    CInput,
    CFlex,
    CBox,
    CIcon,
  },
  name: "RMAReturnSearch",
  props: { searchCallback: { type: Function as PropType<(term: string) => void>, required: true } },
  data() {
    return {
      searchTerm: "",
    };
  },
  methods: {
    search: debounce(function (this: any, term: string) {
      this.searchCallback(term);
    }, 400),
  },
});
</script>
